import './EventLineItem.scss';
import React from 'react';
import { EventTypes } from '../../../Constants/eventtype';
import moment from 'moment';
import classNames from 'classnames';

export interface EventLineItemProps {
  event;
  variant?: 'line' | 'compact';
}

const EventLineItem: React.FC<EventLineItemProps> = ({ event, variant = 'line' }) => {
  return (
    <div
      className={classNames(
        `rbc-event-item rounded d-flex flex-column bg-${EventTypes[event.resource.type].color}-light border border-${
          EventTypes[event.resource.type].color
        }-light`,
        event.resource.data.items[0].closingDate < moment().valueOf() && 'disabled',
        event.resource.data.items[0].closingDate >= moment().valueOf() &&
          event.resource.data.items[0].openingDate <= moment().valueOf() &&
          `border-${EventTypes[event.resource.type].color}`
      )}
      title={event.title}
      onClick={e => {
        e.stopPropagation();
        window.open(`/${event.resource.type}/${event.resource.data.eventNumber}`, '_blank');
      }}>
      {variant === 'line' && (
        <span className={`text-${EventTypes[event.resource.type].color} fw-bold`}>{event.title}</span>
      )}
      <span className="text-muted fw-bold">
        {event.resource.data.city}, {event.resource.data.state}
      </span>
    </div>
  );
};

export default EventLineItem;
